import { toast as rht } from 'react-hot-toast';

export function useToast() {
  return {
    toast: ({ title, description, variant }: { title?: string; description?: string; variant?: string }) => {
      const message = [title, description].filter(Boolean).join(' — ');
      if (variant === 'destructive') {
        rht.error(message || 'An error occurred');
      } else {
        rht.success(message || 'Done');
      }
    },
  };
}

export default useToast;
